import {
    createSelector,
    gettr
} from './utils';

const getForms = (store) => store?.forms ?? {};

export const getFormData = gettr('forms');

export const getHighlighters = createSelector([ getForms ], (f) => f?.highlighter ?? []);

export const getFormValues = createSelector([ getForms ], (f) => f?.values ?? {});

export const getAttachmentsForVisit = createSelector([ getFormValues ], (f) => f?.attachmentsForVisit ?? []);

export const getVisitForScroll = createSelector([ getFormValues ], (f) => f?.visitForScroll);

export const isPhysicianCollectionFetched = createSelector(
    [ getFormValues ],
    (f) => f?.isPhysicianCollectionFetched ?? false,
);
export const getSuggestions = createSelector([ getForms ], (f) => f?.suggestions ?? {});

export const getEditUserPdError = createSelector([ getForms ], (f) => f?.editUserPdError);

export const getManualVisitors = createSelector([ getForms ], (f) => f?.ManualVisitor ?? []);

export const getFormEnrollVisit = createSelector([ getFormValues ], (f) => f?.enrollVisit);
export const getFormEnrollVisitProgram = createSelector([ getFormValues ], (f) => f?.enrollVisitProgram);
